var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"业务备注","visible":_vm.dialogVisible,"width":"600","custom-class":"dialog-title-left"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"min-height":"100px"}},[_vm._v(_vm._s(_vm.remark || '暂无信息'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }